/** EST3 material component kinds — mirrors backend MATERIAL_COMPONENT_KINDS. */
export const EST3_MATERIAL_COMPONENT_KINDS = [
  'BASE',
  'FREIGHT',
  'DUTY',
  'TRANSPORT',
  'HANDLING',
  'WASTAGE',
  'OTHER',
] as const;

export type Est3MaterialComponentKind = (typeof EST3_MATERIAL_COMPONENT_KINDS)[number];

export const EST3_MATERIAL_RATE_SOURCES = [
  'MANUAL',
  'CATALOGUE',
  'LAST_PURCHASE',
  'SUPPLIER_QUOTE',
  'INDEXED',
  'HISTORICAL',
] as const;

export function summarizeMaterialComponents(components: any[]): {
  byKind: Array<{ kind: string; amount: number }>;
  landedTotal: number;
} {
  const map = new Map<string, number>();
  let landedTotal = 0;
  for (const c of components) {
    const kind = String(c.component_kind || 'OTHER');
    const amt = Number(c.amount) || 0;
    map.set(kind, (map.get(kind) || 0) + amt);
    landedTotal += amt;
  }
  const byKind: Array<{ kind: string; amount: number }> = EST3_MATERIAL_COMPONENT_KINDS.map((kind) => ({
    kind,
    amount: map.get(kind) || 0,
  })).filter((x) => x.amount > 0);
  for (const [kind, amount] of map) {
    if (!EST3_MATERIAL_COMPONENT_KINDS.includes(kind as Est3MaterialComponentKind)) {
      byKind.push({ kind, amount });
    }
  }
  return { byKind, landedTotal };
}
